webpackJsonp([213534597649335],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(78);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_React$Component) {
	  _inherits(Post, _React$Component);
	
	  function Post() {
	    _classCallCheck(this, Post);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Post.prototype.render = function render() {
	    var _props$data$node$fron = this.props.data.node.frontmatter,
	        title = _props$data$node$fron.title,
	        date = _props$data$node$fron.date,
	        category = _props$data$node$fron.category,
	        description = _props$data$node$fron.description;
	    var _props$data$node$fiel = this.props.data.node.fields,
	        slug = _props$data$node$fiel.slug,
	        categorySlug = _props$data$node$fiel.categorySlug;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'post' },
	      _react2.default.createElement(
	        'div',
	        { className: 'post__meta' },
	        _react2.default.createElement(
	          'time',
	          { className: 'post__meta-time', dateTime: (0, _moment2.default)(date).format('MMMM D, YYYY') },
	          (0, _moment2.default)(date).format('MMMM YYYY')
	        ),
	        _react2.default.createElement('span', { className: 'post__meta-divider' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'post__meta-category', key: categorySlug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug, className: 'post__meta-category-link' },
	            category
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'post__title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'post__title-link', to: slug },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'post__description' },
	        description
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'post__readmore', to: slug },
	        'Read'
	      )
	    );
	  };
	
	  return Post;
	}(_react2.default.Component);
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Post = __webpack_require__(43);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Sidebar = __webpack_require__(23);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexRoute = function (_React$Component) {
	  _inherits(IndexRoute, _React$Component);
	
	  function IndexRoute() {
	    _classCallCheck(this, IndexRoute);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexRoute.prototype.render = function render() {
	    var items = [];
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	
	    var posts = this.props.data.allMarkdownRemark.edges;
	    posts.forEach(function (post) {
	      items.push(_react2.default.createElement(_Post2.default, { data: post, key: post.node.fields.slug }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: subtitle })
	      ),
	      _react2.default.createElement(_Sidebar2.default, this.props),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content__inner' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              'About me'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'm4ppi(\u307E\u3063\u3074)'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u677E\u672C \u548C\u6A39'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Tokyo'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '1994/09/09'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '2017\u5E7410\u6708\u304B\u3089\u30A8\u30F3\u30B8\u30CB\u30A2\u3068\u3057\u3066\u50CD\u304D\u59CB\u3081\u307E\u3057\u305F\u3002'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u696D\u52D9\u3067\u306F\u3001\u6700\u8FD1\u306Fphp\u3092\u66F8\u3044\u3066\u307E\u3059\u3002 \u4EE5\u524D\u306Fjava\u3092\u30E1\u30A4\u30F3\u306B\u66F8\u3044\u3066\u3044\u3066\u3044\u307E\u3057\u305F\u304C\u3001\u6700\u8FD1\u306F\u307B\u307C\u89E6\u3063\u3066\u306A\u3044\u3067\u3059\u3002 node.js(Express)\u3067\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3082\u643A\u308F\u3063\u3066\u3044\u307E\u3057\u305F\u304C\u3001\u975E\u540C\u671F\u51E6\u7406\u3042\u305F\u308A\u304C\u307E\u3060\u82E6\u624B\u3067\u3059\u3002'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u6700\u8FD1\u306FGo\u8A00\u8A9E\u306B\u30CF\u30DE\u3063\u3066\u3044\u3066\u3001\u7C21\u5358\u306A\u30C4\u30FC\u30EB\u306FGo\u8A00\u8A9E\u3067\u66F8\u3044\u3066\u3044\u307E\u3059\u3002'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u4EE5\u4E0B\u3067\u8A18\u4E8B\u3082\u66F8\u3044\u3066\u307E\u3059\u3002'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.fox-hound.tech/author/kazuki-matsumoto/' },
	                'FOX HOUND TECH'
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Contact'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.twitter.com/m4ppi' },
	                  'twitter'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.github.com/m4ppi' },
	                  'GitHub'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://m4ppi.hatenablog.com' },
	                  '\u306F\u3066\u306A\u30D6\u30ED\u30B0'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://source.unsplash.com/random/800x600', alt: 'unsplash random' })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return IndexRoute;
	}(_react2.default.Component);
	
	exports.default = IndexRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-ac0deebc1c2cbec0acae.js